import { Injectable } from '@angular/core';
import { AES, enc } from 'crypto-js';
import { ENVIRONMENT } from 'src/app/_constants/app.constants';
import { ObjectLiteral } from 'src/app/_models/user';
import { LoggerService } from '../ui/logger/logger.service';
import { ServiceModule } from 'src/app/_services/service.module';

@Injectable({
  providedIn: ServiceModule,
})
export class CryptoService {
  secretKey = ENVIRONMENT.PROPERTIES.AOD_CLIENT_SECRET;
  constructor(
    private logger: LoggerService
  ) { }

  decrypt(textToDecrypt: string) {
    this.logger.debug("CryptoService.decrypt", this)
    let decrypted = AES.decrypt(textToDecrypt, this.secretKey.trim()).toString(enc.Utf8);
    this.logger.debug('EncryptionService : decrypt()', decrypted);
    return decrypted;
  }

  /**
   * @param objectToEncrypt: Object 
   * @returns encrypted object
   */
  encrypt(objectToEncrypt: ObjectLiteral, clientSecret = ENVIRONMENT.PROPERTIES.AOD_CLIENT_SECRET) {
    let encryptString = JSON.stringify(objectToEncrypt);
    let encrypted = AES.encrypt(encryptString, clientSecret.trim()).toString();
    this.logger.debug('EncryptionService : encrypt()', encrypted);
    return encrypted;
  }
}
